import React, {useEffect, useState, useRef} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import Button from "../../components/common/button/Button";
import {AddressWrapped} from '@onegovbugs/onegov-react-components';
import styles from "./YourDetails.module.scss";
import DefaultLayout from "../../layouts/DefaultLayout";
import RadioSelector from "../../components/common/radioSelector/RadioSelector";
import {storeContactData} from "../../redux/actions";
import ErrorMsg from "../../components/common/error/ErrorMsg";

const YourDetails = props => {
  const [errors, setErrors] = useState({
    role: false,
    firstname: false,
    middlename: false,
    lastname: false,
    company: false,
    other: false,
    contactNumber: false,
    emailAddress: false,
    repeatEmail: false,
    postalAddress: false
  });

  const dispatch = useDispatch();
  const contactData = useSelector(state => state.contact);
  const robotData = useSelector(state => state.robot);

  useEffect(() => {
    if(!robotData.notARobot) {
      props.history.push('/')
    }
  }, []);

  const [role, setRole] = useState(contactData.role);
  const [firstname, setFirstname] = useState(contactData.firstname);
  const [middlename, setMiddlename] = useState(contactData.middlename);
  const [lastname, setLastname] = useState(contactData.lastname);
  const [company, setCompany] = useState(contactData.company);
  const [other, setOther] = useState(contactData.other);
  const [contactNumber, setContactNumber] = useState(contactData.contactNumber);
  const [emailAddress, setEmailAddress] = useState(contactData.emailAddress);
  const [repeatEmail, setRepeatEmail] = useState(contactData.repeatEmail);
  const [isAddressValid, setIsAddressValid] = useState(false);
  const [isAddressValidating, setAddressValidating] = useState(false);
  const [postalAddress, setPostalAddress] = useState(contactData.postalAddress);
  const [emailEntered, setEmailEntered] = useState(false);
  const [secondaryEmailEntered, setSecondaryEmailEntered] = useState(false);

    const [warnPartialMatch, setWarnPartialMatch] = useState(false);

  const addressRef = useRef();

  const storeData = () => {
    dispatch(storeContactData({
      role, firstname, middlename, lastname, company,
      contactNumber, emailAddress, repeatEmail, postalAddress, other
    }));
  };

  const clearError = (errName) => {
    const e2 = {...errors};
    e2[errName] = false;
    setErrors(e2);
  }

  const postalAddressLabel = "Postal address (optional)";

  const validateEmailAddress = (address) => {
    var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (role === 'Next of kin')
      return false;
    else
      return address === null || !re.test(String(address).toLowerCase());
  }

  const validateSecondaryEmailAddress = (address1, address2) =>
    role !== 'Next of kin' && address1 !== null && address1 !== address2;


  const isValid = () => {
    const e2 = {...errors};
    e2.role = role === null;
    e2.firstname = firstname === null || (firstname !== null && firstname.length < 2);
    e2.lastname = lastname === null || (lastname !== null && lastname.length < 2);
    //e2.company = !['Next of kin', 'Other'].find(r => r === role) && !company
    e2.other = role === 'Other' && !other
    e2.contactNumber = contactNumber === null;
    e2.emailAddress = validateEmailAddress(emailAddress);
    e2.repeatEmail = validateSecondaryEmailAddress(emailAddress, repeatEmail);

    const isNotValid = Object.keys(e2).reduce((accum, key) => accum || e2[key], false);
    setErrors(e2);

    return !isNotValid;
  }

  useEffect(() => {
    if (!emailEntered)
      return;
    const e2 = {...errors};
    e2.emailAddress = validateEmailAddress(emailAddress);
    setErrors(e2);
  }, [emailAddress, emailEntered]);


  useEffect(() => {
    if (!secondaryEmailEntered)
      return;
    const e2 = {...errors};
    e2.emailAddress = validateEmailAddress(emailAddress);
    e2.repeatEmail = validateSecondaryEmailAddress(emailAddress, repeatEmail);
    setErrors(e2);
  }, [repeatEmail, emailAddress, secondaryEmailEntered]);

  return <DefaultLayout>
    <div className={styles.mainCont}>
      <div className={'row'}>
        <div className={'col-12'}>
          <h2>Your details</h2>
        </div>
        <div className={`col-12 ${styles.firstTitle}`}>
          <RadioSelector
            title={'Which of the following best describe your role?'}
            id={'role'}
            options={[
              {
                value: 'Executor',
                label: 'Executor'
              },
              {
                value: 'Administrator',
                label: 'Administrator'
              },
              {
                value: 'Next of kin',
                label: 'Next of kin'
              },
              {
                value: 'Other',
                label: 'Other'
              }
            ]}
            initialValue={role}
            onSelectionChange={(val) => {
              clearError('role');
              setRole(val);
            }}
          />
        </div>
        {["Other"].find(r => r === role) ?
          [<div className={'col-12 col-md-6'}>
            <p className={styles.smallParagraph}>Other detail</p>
            <input
              className={`${styles.inputBox}`}
              placeholder={'Other detail'}
              value={other}
              onChange={(event) => setOther(event.target.value)}
            />
          </div>,
            <div className={'d-none d-md-block col-6'}>&nbsp;</div>,
            errors.other ?
              <div className={`col-12 ${styles.errorContainer}`}>
                <ErrorMsg
                  type={"error"}
                  description={'Your role detail is required.'}
                />
              </div> : null
          ] : null}
        {errors.role ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"error"}
              description={'Please select a role.'}
            />
          </div> : null}
        <div className={'col-12'}>
          <h3>Your personal details</h3>
        </div>
        <div className={'col-12 col-sm-4'}>
          <p className={styles.smallParagraph}>Given/First Name</p>
          <input
            className={`${styles.inputBox}`}
            placeholder={'Given/First Name'}
            value={firstname}
            onChange={(event) => {
              clearError('firstname');
              setFirstname(event.target.value);
            }}
          />
        </div>
        <div className={'col-12 col-sm-4'}>
          <p className={styles.smallParagraph}>Middle Name (optional)</p>
          <input
            className={`${styles.inputBox}`}
            placeholder={'Middle Name (optional)'}
            value={middlename}
            onChange={(event) => setMiddlename(event.target.value)}
          />
        </div>
        <div className={'col-12 col-sm-4'}>
          <p className={styles.smallParagraph}>Family/Last Name</p>
          <input
            className={`${styles.inputBox}`}
            placeholder={'Family/Last Name'}
            value={lastname}
            onChange={(event) => {
              clearError('lastname');
              setLastname(event.target.value)
            }}
          />
        </div>
        {errors.firstname || errors.lastname ?
          <div className={`col-12 ${styles.errorContainer}`}>
            {errors.firstname ?
              <ErrorMsg
                type={"error"}
                description={'The first name is invalid.'}
              />
              : null}
            {errors.lastname ?
              <ErrorMsg
                type={"error"}
                description={'The last name is invalid.'}
              /> : null}
          </div> : null}
        {["Executor", "Administrator"].find(r => r === role) ?
          [<div className={'col-12 col-md-6'}>
            <p className={styles.smallParagraph}>Company</p>
            <input
              className={`${styles.inputBox}`}
              placeholder={'Company'}
              value={company}
              onChange={(event) => setCompany(event.target.value)}
            />
          </div>,
            <div className={'d-none d-md-block col-6'}>&nbsp;</div>,
            errors.company ?
              <div className={`col-12 ${styles.errorContainer}`}>
                <ErrorMsg
                  type={"error"}
                  description={'The company is required.'}
                />
              </div> : null
          ] : null}
        <div className={'col-12'}>
          <h3>Your contact details:</h3>
        </div>
        <div className={`col-12 col-md-4 ${styles.userDetailField}`}>
          <p className={styles.smallParagraph}>Contact Number</p>
          <input
            className={`${styles.inputBox}`}
            placeholder={'Contact Number'}
            value={contactNumber}
            onChange={(event) => {
              clearError('contactNumber');
              setContactNumber(event.target.value)
            }}
          />
        </div>
        <div className={`d-none d-md-block col-8 ${styles.userDetailField}`}>&nbsp;</div>
        {errors.contactNumber ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"error"}
              description={'The contact number is invalid.'}
            />
          </div> : null}
        <div className={`col-12 col-md-6 ${styles.userDetailField}`}>
          <p className={styles.smallParagraph}>Email Address</p>
          <input
            className={`${styles.inputBox}`}
            placeholder={'Email Address'}
            value={emailAddress}
            onChange={(event) => {
              clearError('emailAddress');
              setEmailAddress(event.target.value)
            }}
            onBlur={() => {
              setEmailEntered(true);
            }}
          />
        </div>
        <div className={`d-none d-md-block col-6 ${styles.userDetailField}`}>&nbsp;</div>
        {errors.emailAddress ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"error"}
              description={'The email address is invalid.'}
            />
          </div> : null}
        {!['Next of kin'].find(r => r === role) ?
          [<div className={`col-12 col-md-6 ${styles.userDetailField}`}>
            <p className={styles.smallParagraph}>Confirm Email Address</p>
            <input
              className={`${styles.inputBox}`}
              placeholder={'Confirm Email Address'}
              value={repeatEmail}
              onChange={(event) => setRepeatEmail(event.target.value)}
              onBlur={() => {
                setSecondaryEmailEntered(true);
              }}
            />
          </div>, <div className={`d-none d-md-block col-6 ${styles.userDetailField}`}>&nbsp;</div>] : null}
        {errors.repeatEmail ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"error"}
              description={'The email addresses do not match.'}
            />
          </div> : null}
          <div className={`col-12 pt-4 ${styles.userDetailField}`}>
          <AddressWrapped
            autoValidate
            label={postalAddressLabel}
            placeholder={' '}
            baseUrl={process.env.REACT_APP_BASE_URL}
            ref={addressRef}
            onChange={(data) => {
              clearError("postalAddress");
              setPostalAddress(data.address);
              }
            }
            value={postalAddress ?? {}}
            onValidationChange={setIsAddressValid}
            onWarningChange={setWarnPartialMatch}
            onLoading={setAddressValidating}
            aria-describedby={errors.postalAddress ? "postalAddressErrorMessage" : undefined }
            aria-invalid={`${errors.postalAddress ? "true" : "false" }`}
          />
        </div>
        {warnPartialMatch ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"warning"}
              description={'The address you entered wasn\'t found, but you can finish the application nonetheless.'}
            />
          </div> : null}
      </div>

      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-6 ${styles.leftCont}`}>
          <Button
            secondary
            onClick={() => {
              window.scrollTo(0, 0);
              props.history.push('/deceased-details')
            }}
          >Back</Button>
        </div>
        <div className={`col-6 ${styles.rightCont}`}>
          <Button
            disabled={isAddressValidating}
            onClick={() => {
              if(!isAddressValidating) {
                storeData();
                if (isValid()) {
                  window.scrollTo(0, 0);
                  props.history.push('/confirm')
                }
              }
            }}
          >Continue</Button>
        </div>
      </div>
    </div>
  </DefaultLayout>
};

export default connect(state => ({
  licenses: state.licenses,
}), {})(YourDetails)
